import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { PushService } from '../../services/push.service';
import { TranslatePipe } from '@ngx-translate/core';
import { AUTH_SERVICE, AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-request-notifications',
  imports: [
    TranslatePipe
  ],
  templateUrl: './request-notifications.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './request-notifications.component.scss',
})
export class RequestNotificationsComponent {

  pushService: PushService = inject(PushService);
  autService: AuthService = inject(AUTH_SERVICE);
  show: boolean = true;


  close(){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }
    this.show = false;
    let originalState = JSON.parse(localStorage.getItem('originalState') || '{"psychologist_connection": true, "notifications": true}');
    originalState.notifications = false;
    localStorage.setItem('originalState', JSON.stringify(originalState));
  }

  async enableNotification(){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }  
    
    let originalState = JSON.parse(localStorage.getItem('originalState') || '{"psychologist_connection": true, "notifications": true}');
    originalState.notifications = false;
    localStorage.setItem('originalState', JSON.stringify(originalState));
    this.show = false;

    const userId = this.autService.user()?.id;
    if(userId){
      await this.pushService.requestPermissionAndSubscribe(userId);
    }
  }

}
